



















import { Component, Vue, Prop } from 'vue-property-decorator';
import Modal from '@/components/common/Modal.vue';
import CollectionList from '@/components/collections/CollectionList.vue';
import { QuestionLanguage } from '@/resource/subject/subject.model';

@Component({
  components: {
    Modal,
    CollectionList,
  },
})
export default class ModalAddQuestion extends Vue {
  @Prop()
  showAddQuestion!: boolean;

  @Prop()
  closeAddQuestion!: () => void;

  @Prop({ default: 0 })
  questionId!: number;

  @Prop({ default: 0 })
  answerPosition!: number;

  @Prop({ required: true })
  isObjective!: boolean;

  @Prop({ required: true })
  languages!: QuestionLanguage[];

  width = '800px';
  title = 'Add to collections';
  description = `Add this question to collection. You can pile up questions in collection and you can create pdf per collection. 
  Choose which collection you want to add this question, or create a new one.`;
}
